import React from 'react'
import styled from '@emotion/styled'

import CheckCircle from './checkDot'
import { blueDark10, fontSize3XSmall, grayLight20 } from '../../constants/principles'

export default ({ colorCode, colorName, colorId, isSelected, onClick }) => (
  <StyledContainerDiv onClick={e => onClick(colorId)}>
    <StyledColorDiv data-testid={`btn-select-color-${colorName}`} isSelected={isSelected} colorCode={colorCode}>
      {isSelected && <CheckCircle color={blueDark10} />}
    </StyledColorDiv>
    <StyledTextDiv>{colorName}</StyledTextDiv>
  </StyledContainerDiv>
)

const StyledContainerDiv = styled.div`
  padding: 4px;
  display: inline-block;
`

const StyledTextDiv = styled.div`
  text-align: center;
  font-size: ${fontSize3XSmall};
`

const StyledColorDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.colorCode};
  border: 1px solid ${grayLight20};
  ${p => (p.isSelected ? `border: 4px solid ${blueDark10}` : '')};
  border-radius: 8px;
  height: 50px;
  width: 50px;
`
